import type { IndexingStatus } from '@vrzl/database';

const TERMINAL_INDEXING_STATUSES: ReadonlySet<IndexingStatus> = new Set([
  'INDEXED',
  'FAILED_WITH_ERRORS',
]);

export const isIndexingTerminal = (status: IndexingStatus): boolean =>
  TERMINAL_INDEXING_STATUSES.has(status);

/**
 * Extractie mag starten wanneer elk document klaar is (succes of mislukt)
 * én er minstens één succesvol geïndexeerd document is.
 */
export const canStartExtraction = (
  docs: ReadonlyArray<{ indexingStatus: IndexingStatus }>,
): boolean =>
  docs.length > 0 &&
  docs.every((d) => isIndexingTerminal(d.indexingStatus)) &&
  docs.some((d) => d.indexingStatus === 'INDEXED');
